import { DETAILS_APPLY_FOR } from '../constants'
import { calculateDimensionToCm, calculateWeightToKg } from './common'

export const getShipmentClassificationRequest = (rows = [], options = {}) => {
	const dimensionDetails = rows.map((row) => {
		const pieces = Math.max(parseFloat(row.pieces) || 1, 1)
		const weightKg = parseFloat(calculateWeightToKg(parseFloat(row.weight) || 0, row.weightUnit || 'K')) || 0
		const weightPerPieceKg = row.weightType === DETAILS_APPLY_FOR.PER_ITEM ? weightKg : weightKg / pieces
		return {
			pieceCount: pieces,
			lengthCm: Math.max(parseFloat(calculateDimensionToCm(row.length || 0, row.dimensionUnit || 'C')) || 0, 0.001),
			widthCm: Math.max(parseFloat(calculateDimensionToCm(row.width || 0, row.dimensionUnit || 'C')) || 0, 0.001),
			heightCm: Math.max(parseFloat(calculateDimensionToCm(row.height || 0, row.dimensionUnit || 'C')) || 0, 0.001),
			weightPerPieceKg: Math.max(parseFloat(weightPerPieceKg.toFixed(3)), 0.001),
			isStackable: row.stackable === true || row.stackable === 'Y',
			isTiltable: row.turnable === true || row.turnable === 'Y' || row.tiltable === true || row.tiltable === 'Y',
		}
	})
	const totalWeight = options.totalWeight != null && options.totalWeight !== ''
		? Number(calculateWeightToKg(Number(options.totalWeight), options.weightUnit || 'K'))
		: rows.reduce((total, row) => {
			const rowWeight = Number(calculateWeightToKg(Number(row.weight) || 0, row.weightUnit || 'K'))
			return total + (row.weightType === DETAILS_APPLY_FOR.PER_ITEM ? rowWeight * Number(row.pieces) : rowWeight)
		}, 0)
	return {
		operationFlag: options.operationFlag || 'I',
		aircraftTypeCode: '77X',
		carrierCode: 'EY',
		totalPieces: rows.reduce((total, row) => total + (Number(row.pieces) || 0), 0),
		totalWeight: Number(totalWeight.toFixed(3)),
		dimensionUnit: 'cm',
		weightUnit: 'kg',
		dimensionDetails,
	}
}

export const getShipmentClassificationSignature = (rows = [], options = {}) =>
	JSON.stringify(getShipmentClassificationRequest(rows, options))